// tabs
export const SET_TABS = 'SET_TABS'
// currentTabName
export const SET_CURRENTTABVALUE = 'SET_CURRENTTABVALUE'
// user -> token
export const SET_TOKEN = 'SET_TOKEN'
// user -> name
export const SET_NAME = 'SET_NAME'
// user -> avatar
export const SET_AVATAR = 'SET_AVATAR'
// user -> menus
export const SET_MENUS = 'SET_MENUS'
// user -> productionLineId
export const SET_PRODUCTIONLINEID = 'SET_PRODUCTIONLINEID'
// permission -> routers
export const SET_ROUTERS = 'SET_ROUTERS'
// dashboard -> name
export const SET_DASHNAME = 'SET_DASHNAME'
// dashboard -> layout
export const SET_LAYOUT = 'SET_LAYOUT'
// dashboard -> datas
export const SET_DATAS = 'SET_DATAS'
// dashboard -> editorId
export const SET_EDITORID = 'SET_EDITORID'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js